// REDUX ACTION TYPES
export const ACTION_TYPES = {
  // auth
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  UPDATE_USERS: 'UPDATE_USER',
  CHECK_REMENBERED_USER_DONE: 'CHECK_REMENBERED_USER_DONE',
  UPDATE_TOURNAMENT_OPTIONS: 'UPDATE_TOURNAMENT_OPTIONS',
};
